import styled from 'styled-components';
import { typography } from '../../typography/typography.js';

// Styled components for TextArea
var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1ummnf9-0"
})(["width:295px;font-family:", ";display:flex;flex-flow:column nowrap;", ""], typography.fontFamily, function (_ref) {
  var rootStyle = _ref.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var InputArea = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "styledComponents__InputArea",
  componentId: "sc-1ummnf9-1"
})(["padding:5px;margin:0;font-family:", ";font-size:", ";font-weight:300;line-height:", ";resize:none;border-style:solid;border-width:1px;&:disabled{color:", ";background-color:", ";}::placeholder{color:", ";text-transform:initial;}", " ", ""], typography.fontFamily, typography.fontSize, typography.lineHeight, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, function (_ref5) {
  var hasError = _ref5.hasError,
      theme = _ref5.theme;

  if (hasError) {
    return "border-color: ".concat(theme.colorPalette.utilityColors.error, ";");
  }

  return "\n      border-color: ".concat(theme.colorPalette.neutralColors.light.shade_dark_3, ";\n      &:focus {\n        border-color: ").concat(theme.colorPalette.primaryColors.main.shade_default, ";\n      }\n    ");
}, function (_ref6) {
  var inputAreaStyle = _ref6.inputAreaStyle;
  return inputAreaStyle;
});
process.env.NODE_ENV !== "production" ? InputArea.displayName = 'InputArea' : void 0;
var LabelRow = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__LabelRow",
  componentId: "sc-1ummnf9-2"
})(["display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:flex-end;width:100%;"]);
process.env.NODE_ENV !== "production" ? LabelRow.displayName = 'LabelRow' : void 0;
var MaxLength = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__MaxLength",
  componentId: "sc-1ummnf9-3"
})(["font-size:", ";line-height:", ";color:", ";margin-bottom:7px;", ""], typography.fontSizeSmall, typography.lineHeight, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
}, function (_ref8) {
  var maxLengthStyle = _ref8.maxLengthStyle;
  return maxLengthStyle;
});
process.env.NODE_ENV !== "production" ? MaxLength.displayName = 'MaxLength' : void 0;
/**
 * NOTE: Copied from TextInput styledComponents; we should consider handling this using custom styles, but it requires
 * us to handle tooltip as a string rather than a component
 */

var TooltipContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__TooltipContainer",
  componentId: "sc-1ummnf9-4"
})(["padding-left:6px;"]);
process.env.NODE_ENV !== "production" ? TooltipContainer.displayName = 'TooltipContainer' : void 0;

export { InputArea, LabelRow, MaxLength, Root, TooltipContainer };
